import React from 'react';
import { FaUserShield, FaChartLine, FaUsers } from 'react-icons/fa';
import './LandingCRM.css';

const LandingCRM = () => {
    return (
        <section className="landing-section landing-crm">
            <div className="crm-container">
                <div className="crm-header">
                    <h2 className="section-title">Unbot est aussi un CRM puissant</h2>
                    <p className="section-subtitle">
                        Sécurisez votre compte Uncove et gérez votre équipe sans risque.
                    </p>
                </div>

                <div className="crm-grid">
                    <div className="crm-card">
                        <div className="crm-icon-wrapper shield">
                            <FaUserShield />
                        </div>
                        <h3>Sécurité Maximale</h3>
                        <p>
                            Vos chatters se connectent à Unbot, <strong>jamais à Uncove</strong>.
                            Ne partagez plus vos mots de passe. Votre compte reste 100% sécurisé.
                        </p>
                    </div>

                    <div className="crm-card">
                        <div className="crm-icon-wrapper users">
                            <FaUsers />
                        </div>
                        <h3>Gestion d'Équipe</h3>
                        <p>
                            Créez des rôles sur mesure : Chatter, Manager.
                            Attribuez des permissions spécifiques et gardez le contrôle total.
                        </p>
                    </div>

                    <div className="crm-card">
                        <div className="crm-icon-wrapper chart">
                            <FaChartLine />
                        </div>
                        <h3>Analytics Avancés</h3>
                        <p>
                            Suivez les performances de chaque membre de l'équipe en temps réel.
                            Ventes, conversion : tout est mesuré.
                        </p>
                    </div>


                </div>
            </div>
        </section>
    );
};

export default LandingCRM;
